import React from "react";
import styled from "styled-components";

import bg from '../img/bg-testimonial.jpg';

const NotFound = styled.ul`
  background: ${'url(' + bg + ')'} #E7F8FC center bottom no-repeat;
  background-size: cover !important;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  h1 {
    font-size: 52px;
  }
  h2 {
    font-size: 36px;
  }
`;

export default NotFound;



// WEBPACK FOOTER //
// ./src/styled-components/NotFound.js